import React, { Component } from 'react'
import Table from '@common/Table'
import columns from './columns'
import { observer } from 'mobx-react'
@observer
export default class extends Component {
  render() {
    return (
      <Table
        store={this.props.store}
        columns={columns(this.props.store, this.props.indexStore)}
        scroll={{ y: 264 }}
      />
    )
  }
}
